import React from "react";
import Divider from "./Divider";

const GridDetailsLayout = ({ dataConfig }) => {
    const filteredDataConfig = dataConfig.filter(({ value }) => value);

    return (
        <div className="grid w-full grid-cols-1 gap-x-6 gap-y-5 pb-2 md:grid-cols-3">
            {filteredDataConfig?.map(({ key, value }, idx) => {
                const shouldShowDivider =
                    (idx + 1) % 3 === 0 &&
                    idx !== filteredDataConfig?.length - 1;

                return (
                    <React.Fragment key={key}>
                        <div className="flex items-center gap-1.5">
                            <span className="whitespace-nowrap text-sm font-medium text-gray-700">
                                {key}:
                            </span>

                            <div className="text-sm font-medium text-gray-800">
                                {value}
                            </div>
                        </div>

                        {shouldShowDivider && (
                            <Divider className="col-span-full" />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default GridDetailsLayout;
